<template>
  <div class="w-full flex flex-col brand-progress-wrap" :style="{'--startProgress':startProgress}">
    <div class="flex-1 relative ">
      <div class="back-progress-wrap "></div>
      <div class="front-progress-wrap"></div>
    </div>

    <div class="flex flex-row items-center justify-between mt-4 text-14px  third-color">
      <span v-for="(item,index) in steps" :ref="`step${index+1}`" :class="step >= index ? 'active-step': ''" @click="onStepClick(index)">
        {{ item.name }}
      </span>
    </div>
  </div>
</template>

<script>
import log from '@/util/log'
export default {
  name: "BrandProgress",
  props: {
    step: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      steps: [{
        name: "Brand",
        centerX: 0
      }, {
        name: "Product",
        centerX: 0
      }, {
        name: "Flavor",
        centerX: 0
      }, {
        name: "Write Data",
        centerX: 0
      }],
      startProgress: 0
    };
  },
  watch: {
    step(newStep) {
      log(`new step = ${newStep}`)
      this.startProgress = this.steps[newStep].centerX;
    }
  },
  methods: {
    onStepClick(index) {
      if (index === 3) {
        this.$router.push('/customization/history')
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      for (let i = 0; i < this.steps.length - 1; i++) {
        const el = this.$refs[`step${i + 1}`][0];
        this.steps[i].centerX = `${el.offsetLeft - 16 + el.getBoundingClientRect().width / 2}px`;
      }
      this.steps[3].centerX = `100%`;
      this.startProgress = this.steps[this.step].centerX;
    });

  },
};
</script>

<style scoped lang="less">
.brand-progress-wrap {
}

.back-progress-wrap {
  position: absolute;
  height: 8px;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  border-radius: 4px;
  background: white;
  flex: 1;
}

.front-progress-wrap {
  width: var(--startProgress);
  position: absolute;
  height: 8px;
  top: 0;
  left: 0;
  bottom: 0;
  border-radius: 4px;
  background: white;
  background: #121212;
  flex: 1;
  transition: all 1s ease-in-out;
}

.active-step {
  color: #333333;
}


</style>